
import React, { useState, useEffect } from 'react';
import { TECH_WORDS } from '../services/localData';

const Hangman: React.FC = () => {
  const [word, setWord] = useState("");
  const [guessed, setGuessed] = useState<string[]>([]);
  const [mistakes, setMistakes] = useState(0);
  const maxMistakes = 6;

  const initGame = () => {
    setWord(TECH_WORDS[Math.floor(Math.random() * TECH_WORDS.length)]);
    setGuessed([]);
    setMistakes(0);
  };

  useEffect(() => initGame(), []);

  const handleGuess = (letter: string) => {
    if (guessed.includes(letter) || mistakes >= maxMistakes || isWon) return;
    setGuessed(prev => [...prev, letter]);
    if (!word.includes(letter)) setMistakes(prev => prev + 1);
  };

  const isWon = word && word.split('').every(l => guessed.includes(l));
  const isLost = mistakes >= maxMistakes;

  return (
    <div className="flex flex-col items-center max-w-xl w-full game-transition">
      <div className="mb-12 text-center">
        <div className="text-5xl md:text-6xl mb-4 font-mono tracking-[0.4em] text-white flicker">
          {word.split('').map((l, i) => (
            <span key={i} className="border-b-4 border-slate-700 mx-1 min-w-[1em] inline-block">
              {guessed.includes(l) || isLost ? l : " "}
            </span>
          ))}
        </div>
        <p className="text-slate-500 font-bold uppercase tracking-widest text-xs">MISTAKES: {mistakes} / {maxMistakes}</p>
      </div>

      {(isWon || isLost) && (
        <div className={`mb-8 p-6 rounded-xl text-center w-full border ${isWon ? 'bg-green-900/20 text-green-400 border-green-800' : 'bg-red-900/20 text-red-400 border-red-800'}`}>
          <h2 className="text-2xl font-black mb-2">{isWon ? "MISSION SUCCESS!" : "SYSTEM FAILURE"}</h2>
          <p className="mb-4 text-sm font-mono uppercase">Decrypted Word: <span className="font-black text-white">{word}</span></p>
          <button onClick={initGame} className="bg-slate-700 hover:bg-slate-600 text-white px-8 py-2 rounded-full font-bold transition-all">REBOOT GAME</button>
        </div>
      )}

      <div className="flex flex-wrap justify-center gap-2">
        {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('').map(l => (
          <button
            key={l}
            disabled={guessed.includes(l) || isWon || isLost}
            onClick={() => handleGuess(l)}
            className={`w-10 h-10 rounded-lg font-black transition-all transform active:scale-90 ${
              guessed.includes(l) 
                ? word.includes(l) ? 'bg-green-600 text-white' : 'bg-slate-800 text-slate-600'
                : 'bg-slate-800 hover:bg-blue-600 text-white border border-slate-700'
            }`}
          >
            {l}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Hangman;
